"use client";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import apiEndpoints from "../apiconfig";
import bgImage from "../assets/mainback.jpg";

const Login = () => {
  const [isRegister, setIsRegister] = useState(false);
  const navigate = useNavigate();

  // --- STATE ---
  const [companyName, setCompanyName] = useState("");
  const [primaryContactName, setPrimaryContactName] = useState("");
  const [wabaNumber, setWabaNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // --- PASSWORD VISIBILITY STATES ---
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [showRegisterPassword, setShowRegisterPassword] = useState(false);

  // --- ERROR STATES ---
  const [errors, setErrors] = useState({});

  // --- LOGIN ---
  const handleLogin = async () => {
    let tempErrors = {};
    if (!email) tempErrors.email = "Email is required";
    if (!password) tempErrors.password = "Password is required";

    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) return;

    try {
      const res = await fetch(`${apiEndpoints.getProfile}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "login", email, password }),
      });

      const data = await res.json();
      console.log(data);

      if (data.status === "success") {
        localStorage.setItem("token", data.token);
        localStorage.setItem("waba_number", data.user.waba_number);
        navigate("/dashboard");
      } else {
        setErrors({ email: "Invalid email or password" });
      }
    } catch (err) {
      console.error(err);
      setErrors({ email: "Failed to connect to server" });
    }
  };

  // --- REGISTER ---
  const handleRegister = async () => {
    let tempErrors = {};
    if (!companyName) tempErrors.companyName = "Company Name is required";
    if (!primaryContactName)
      tempErrors.primaryContactName = "Primary Contact Name is required";
    if (!wabaNumber) tempErrors.wabaNumber = "WhatsApp Number is required";
    if (!email) tempErrors.email = "Email is required";
    if (!password) tempErrors.password = "Password is required";

    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) return;

    try {
      const res = await fetch(`${apiEndpoints.getProfile}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "register",
          companyName,
          primaryContactName,
          waba_number: wabaNumber,
          email,
          password,
        }),
      });

      const data = await res.json();
      console.log(data);

      if (data.status === "success") {
        setIsRegister(false);
      } else {
        setErrors({ email: data.message });
      }
    } catch (err) {
      console.error(err);
      setErrors({ email: "Failed to connect to server" });
    }
  };

  return (
   <div className="w-full min-h-screen relative flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-70"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      ></div>
       <div className="relative w-full max-w-6xl bg-white rounded-3xl shadow-xl overflow-hidden">
        <div className="flex flex-col md:flex-row">
          {/* Left Side Form */}
          <div className="w-full md:w-1/2 flex items-center justify-center p-4 md:p-8">
            <div className="w-full max-w-md">
              <h2 className="text-2xl md:text-3xl font-bold text-center text-[#25D366] mb-6">
                {isRegister ? "Create Account" : "Login"}
              </h2>

              {isRegister ? (
                <>
                  {/* Company Name */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium mb-1 text-black">
                      Company Name
                    </label>
                    <input
                      type="text"
                      placeholder="Enter company name"
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                      className={`w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 ${errors.companyName
                        ? "border-red-500 focus:ring-red-500"
                        : "border-[#25D366] focus:ring-[#25D366]"
                        }`}
                    />
                    {errors.companyName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.companyName}
                      </p>
                    )}
                  </div>

                  {/* Primary Contact Name */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium mb-1 text-black">
                      Primary Contact Name
                    </label>
                    <input
                      type="text"
                      placeholder="Enter primary contact name"
                      value={primaryContactName}
                      onChange={(e) => setPrimaryContactName(e.target.value)}
                      className={`w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 ${errors.primaryContactName
                        ? "border-red-500 focus:ring-red-500"
                        : "border-[#25D366] focus:ring-[#25D366]"
                        }`}
                    />
                    {errors.primaryContactName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.primaryContactName}
                      </p>
                    )}
                  </div>

                  {/* WhatsApp Number */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium mb-1 text-black">
                      Mobile / WhatsApp Number
                    </label>
                    <div className="flex gap-2">
                      <select
                        className="w-1/3 border border-[#25D366] rounded-lg px-2 py-2 outline-none focus:ring-2 focus:ring-[#25D366] text-[#25D366] bg-white"
                        value="+91"
                        disabled
                      >
                        <option>+91</option>
                      </select>
                      <input
                        type="text"
                        placeholder="Enter WhatsApp number"
                        value={wabaNumber}
                        onChange={(e) => setWabaNumber(e.target.value)}
                        className={`w-2/3 border rounded-lg px-3 py-2 outline-none focus:ring-2 ${errors.wabaNumber
                          ? "border-red-500 focus:ring-red-500"
                          : "border-[#25D366] focus:ring-[#25D366]"
                          }`}
                      />
                    </div>
                    {errors.wabaNumber && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.wabaNumber}
                      </p>
                    )}
                  </div>

                  {/* Email */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium mb-1 text-black">
                      Email
                    </label>
                    <input
                      type="email"
                      placeholder="Enter email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={`w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 ${errors.email
                        ? "border-red-500 focus:ring-red-500"
                        : "border-[#25D366] focus:ring-[#25D366]"
                        }`}
                    />
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>

                  {/* Password (with Eye Toggle) */}
                  <div className="mb-4 relative">
                    <label className="block text-sm font-medium mb-1 text-black">
                      Password
                    </label>
                    <div className="relative">
                      <input
                        type={showRegisterPassword ? "text" : "password"}
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={`w-full border rounded-lg px-3 py-2 pr-10 outline-none focus:ring-2 ${errors.password
                          ? "border-red-500 focus:ring-red-500"
                          : "border-[#25D366] focus:ring-[#25D366]"
                          }`}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowRegisterPassword(!showRegisterPassword)
                        }
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-[#25D366] focus:outline-none"
                      >
                        {showRegisterPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    {errors.password && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.password}
                      </p>
                    )}
                  </div>

                  <button
                    onClick={handleRegister}
                    className="w-full bg-[#25D366] text-white py-3 rounded-lg font-semibold hover:bg-[#20c05a] transition duration-200 focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-opacity-50"
                  >
                    Sign Up
                  </button>

                  <p className="text-center text-sm mt-4 text-gray-600">
                    Already have an account?{" "}
                    <button
                      className="text-[#25D366] font-semibold hover:underline focus:outline-none"
                      onClick={() => setIsRegister(false)}
                    >
                      Login instead
                    </button>
                  </p>
                </>
              ) : (
                <>
                  {/* Email */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium mb-1 text-black">
                      Email
                    </label>
                    <input
                      type="email"
                      placeholder="Enter email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={`w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 ${errors.email
                        ? "border-red-500 focus:ring-red-500"
                        : "border-[#25D366] focus:ring-[#25D366]"
                        }`}
                    />
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>

                  {/* Password (with Eye Toggle) */}
                  <div className="mb-6 relative">
                    <label className="block text-sm font-medium mb-1 text-black">
                      Password
                    </label>
                    <div className="relative">
                      <input
                        type={showLoginPassword ? "text" : "password"}
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={`w-full border rounded-lg px-3 py-2 pr-10 outline-none focus:ring-2 ${errors.password
                          ? "border-red-500 focus:ring-red-500"
                          : "border-[#25D366] focus:ring-[#25D366]"
                          }`}
                      />
                      <button
                        type="button"
                        onClick={() => setShowLoginPassword(!showLoginPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-[#25D366] focus:outline-none"
                      >
                        {showLoginPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    {errors.password && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.password}
                      </p>
                    )}
                  </div>

                  <button
                    onClick={handleLogin}
                    className="w-full bg-[#25D366] text-white py-3 rounded-lg font-semibold hover:bg-[#20c05a] transition duration-200 focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-opacity-50"
                  >
                    Login
                  </button>

                  {/* <p className="text-center text-sm mt-4 text-gray-600">
                    Don't have an account?{" "}
                    <button
                      className="text-[#25D366] font-semibold hover:underline focus:outline-none"
                      onClick={() => setIsRegister(true)}
                    >
                      Sign up
                    </button>
                  </p> */}
                </>
              )}
            </div>
          </div>

          {/* Right Side Image */}
          <div className="hidden md:block w-full md:w-1/2 h-64 md:h-auto relative">
            <img
              src="image1.png"
              alt="Auth Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#25D366]/5"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;